module.exports = __webpack_public_path__ + "static/media/small-green-1.85a7448d.png";